import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';

import {ErrorReportBoundary} from '@homeaway/react-error-reporter';

import ListingActions from '../../actions/listingActions';

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
    const listingActions = bindActionCreators(ListingActions, dispatch);

    return {
        actions: {
            logToServer: listingActions.logToServer
        }
    };
}

const ErrorBoundary = ({label, children, actions: {logToServer}, ...rest}) => (
    <ErrorReportBoundary
        name={label}
        fallbackUI={<div />}
        onError={(error, info) => {
            let errorInfo = {ErrorBoundary: label};

            if (error.message) {
                errorInfo.message = error.message;
            }
            if (error.stack) {
                errorInfo.stack = error.stack;
            }

            if (info && Object.keys(info).length > 0) {
                const serializedInfo = JSON.stringify(info);
                errorInfo.info = serializedInfo;
            }
            logToServer(errorInfo);
        }}
        {...rest}
    >
        {children}
    </ErrorReportBoundary>
);

export {ErrorBoundary};

export default connect(
    null,
    mapDispatchToProps
)(ErrorBoundary);
